@if (blockUi) {
  <div class="loading-image-container">
    <div class="loading-image small"></div>
    <div class="loading-text">Loading ...</div>
  </div>
}

<mat-sidenav-container>
  <mat-sidenav position="end" mode="over" class="field-editor-sidebar" #rightside mat-component-id="rightside">
    <aw-location-attribute-editor [field]="locationAttributesService.getEditAttribute()" (closePanel)="closeRightSidePanel()"></aw-location-attribute-editor>
  </mat-sidenav>
  <section class="container">
    <div class="header-wrapper">
      <h1>{{ headerText }}</h1>
    </div>
    <div class="content-wrapper">
      <aw-route-filter [placeHolderText]="filterPlaceHolderText" [filterName]="'attributeFilter'"></aw-route-filter>
      <mat-panel-title><h4>{{'Attribute Details' | translate: 'Text' | async }}</h4></mat-panel-title>
      <div class="attributes-container">
        @for (attribute of getOrderedAttributes() | callbackPipe : filterAttributes : [attributeFilter]; track attribute) {
          <div class="attribute-container" [ngClass]="{'field-hidden': attribute.IsDeactivated}" >
            <div class="left controls">
              <div>
                <label>Active</label>
                <mat-slide-toggle
                  (change)="toggleActive(attribute, $event)"
                  [checked]="attribute.IsDeactivated"
                color="warn"></mat-slide-toggle>
              </div>
            </div>
            <div class="field-detail" (click)="openFieldModalComponent(attribute)">
              <div><strong [title]="'fieldId: ' + attribute.AttributeId | translate: 'Text' | async">{{attribute.AttributeId | translate: 'Text' | async}}</strong></div>
              <div [title]="'FieldUniqueId: ' + attribute.AttributeUniqueId"><em>{{attribute.AttributeUniqueId }}</em></div>
            </div>
            <div class="field-content" (click)="openFieldModalComponent(attribute)">
              <div [title]="'FieldName: ' + attribute.AttributeName | translate: 'Text' | async">{{attribute.AttributeName | translate: 'Text' | async}}</div>
              <div [title]="'HelpText: ' + attribute.HelpText | translate: 'Text' | async">{{attribute.HelpText | translate: 'Text' | async}}</div>
            </div>
            <div>
              <span>
                <a mat-raised-button class="mat-accent tableBtn" (click)="locationAttributesService.startEditingAttribute(attribute)"><mat-icon>edit</mat-icon></a>
                <a mat-raised-button class="mat-warn tableBtn" (click)="locationAttributesService.deleteAttribute(attribute)" [id]="'deleteAttribute' + attribute.AttributeId"><span class="hide">Delete</span><mat-icon>delete</mat-icon></a>
              </span>
            </div>
            <div class="right controls">
              <button mat-icon-button (click)="reorderField(attribute, 0)">
                <mat-icon>arrow_drop_up</mat-icon>
              </button>
              <button mat-icon-button (click)="reorderField(attribute, 1)">
                <mat-icon>arrow_drop_down</mat-icon>
              </button>
            </div>
          </div>
        }
      </div>
      <div style="margin-top: 15px;margin-bottom: 15px">
        <a mat-raised-button class="mat-accent" (click)="locationAttributesService.startAddingAttribute()" data-qa-id="hierarchy-attributes-btn-add">Add Attribute</a>
      </div>
    </div>
  </section>
</mat-sidenav-container>
